import React from 'react';

function getInitials(name) {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getAvatarColor(name) {
    const palette = ['#64748b', '#7c6f8a', '#8b6f47', '#5e7a6a', '#6b7488', '#846a7a', '#7a6d52'];
    let hash = 0;
    for (let i = 0; i < String(name || '').length; i++) hash = (hash * 31 + name.charCodeAt(i)) & 0xffffffff;
    return palette[Math.abs(hash) % palette.length];
}

export default function CustomerCard({ row, onClick, isActive }) {
    const fullName = row.entity_full_name || row.entity_name || '—';
    const phone = row.entity_contact_phone;
    const meta = [row.entity_legal_id, row.entity_adm1_name].filter(Boolean).join(' · ');
    const loyalty = row.entity_loyalty_level;
    const tagList = Array.isArray(row.tags) ? row.tags.slice(0, 2) : [];

    return (
        <div className={'apk-card' + (isActive ? ' apk-card--active' : '')} onClick={() => onClick && onClick(row)}>
            <div className="apk-card__avatar" style={{ background: getAvatarColor(fullName) }}>
                {getInitials(fullName)}
            </div>
            <div className="apk-card__main">
                <div className="apk-card__line1">
                    <span className="apk-card__name">{fullName}</span>
                    {loyalty && <span className="apk-card__chip apk-card__chip--loyalty">{loyalty}</span>}
                    {tagList.map((t) => (
                        <span key={t} className="apk-card__chip">#{t}</span>
                    ))}
                </div>
                <div className="apk-card__line2">
                    {phone && <span className="apk-card__phone">{phone}</span>}
                    {phone && meta && <span className="apk-card__sep">·</span>}
                    {meta && <span>{meta}</span>}
                </div>
            </div>
            <div className="apk-card__chevron">›</div>
        </div>
    );
}
